const validate = values => {
  const errors = {}

  if (!values.title) {
    errors.title = "The title is required"
  }

  if (!values.content) {
    errors.content = "This field is required"
  }

  if (values.linkText) {
    if (!values?.link) {
      errors.link = "The link is required"
    } else if (
      !(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values?.link) ||
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
          values?.link
        ) ||
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
          values?.link
        )
      )
    ) {
      errors.link =
        "Link should be an URL(include http:// or https://), a phone number or an email"
    }
    if (!values?.linkIcon) {
      errors.linkIcon = "The icon is required"
    }
  }

  if (values?.link) {
    if (
      !(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values?.link) ||
        /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
          values?.link
        ) ||
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
          values?.link
        )
      )
    ) {
      errors.link =
        "Link should be an URL(include http:// or https://), a phone number or an email"
    }
    if (!values?.linkText) {
      errors.linkText = "The link text is required"
    }
    if (!values?.linkIcon) {
      errors.linkIcon = "The icon is required"
    }
  }

  return errors
}

export default validate
